import { ComponentProps, FC, PropsWithChildren } from 'react';
import { CatTooltip } from '@blocks-react/components/Tooltip';
import { BlocksCloseEvent } from '@blocks-web-components/events/blocks-close';

type CatToolTipProps = ComponentProps<typeof CatTooltip>;

export const MyEquipmentToolTip: FC<PropsWithChildren<CatToolTipProps>> = ({
  children,
  ...toolTipProps
}) => {
  const onCloseTooltip = (e: BlocksCloseEvent) => {
    e.stopPropagation();
  };
  return (
    <CatTooltip
      onBlTooltipClose={(e: BlocksCloseEvent) => onCloseTooltip(e)}
      onBlTooltipOpen={(e: BlocksCloseEvent) => onCloseTooltip(e)}
      {...toolTipProps}
    >
      {children}
    </CatTooltip>
  );
};
